import React from 'react';
import { DailyDataPoint } from '../utils/goalData';
interface DailyBreakdownProps {
  dailyData: DailyDataPoint[];
  daysPassed: number;
}
export function DailyBreakdown({
  dailyData,
  daysPassed
}: DailyBreakdownProps) {
  const dailyIncrements = dailyData.map((d, i) => {
    const prevSP = i > 0 ? dailyData[i - 1].softPullActual : 0;
    const prevSub = i > 0 ? dailyData[i - 1].submittedActual : 0;
    return {
      label: d.label,
      day: d.day,
      softPull: d.day <= daysPassed ? d.softPullActual - prevSP : null,
      submitted: d.day <= daysPassed ? d.submittedActual - prevSub : null,
      isToday: d.day === daysPassed,
      isPast: d.day < daysPassed,
      isFuture: d.day > daysPassed
    };
  });
  return <section className="bg-slate-800/80 rounded-2xl border border-slate-700/50 p-6" style={{
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
  }} aria-label="Daily breakdown" data-id="element-1">
      <h3 className="text-lg font-semibold text-white mb-1" data-id="element-2">Daily Breakdown</h3>
      <p className="text-sm text-slate-400 mb-5" data-id="element-3">
        Activity per day this period
      </p>

      <div className="grid grid-cols-7 gap-2" data-id="element-4">
        {dailyIncrements.map(d => <div key={d.day} className={`rounded-xl p-3 text-center transition-all ${d.isToday ? 'bg-indigo-500/10 ring-1 ring-indigo-500/40' : d.isPast ? 'bg-slate-700/50' : 'bg-slate-800/50 opacity-40'}`} style={d.isToday ? {
        boxShadow: '0 0 15px rgba(129, 140, 248, 0.15)'
      } : undefined} data-id="element-5">
            <p className={`text-xs font-medium mb-2 ${d.isToday ? 'text-indigo-400' : 'text-slate-500'}`} data-id="element-6">
              {d.label}
            </p>
            {d.softPull !== null ? <>
                <div className="mb-1" data-id="element-7">
                  <span className="text-lg font-bold text-indigo-400" data-id="element-8">
                    {d.softPull}
                  </span>
                  <p className="text-[10px] text-slate-500 mt-0.5" data-id="element-9">SP</p>
                </div>
                <div data-id="element-10">
                  <span className="text-lg font-bold text-cyan-400" data-id="element-11">
                    {d.submitted}
                  </span>
                  <p className="text-[10px] text-slate-500 mt-0.5" data-id="element-12">Sub</p>
                </div>
              </> : <div className="py-3" data-id="element-13">
                <span className="text-xs text-slate-600" data-id="element-14">—</span>
              </div>}
          </div>)}
      </div>
    </section>;
}